'use client';

import { useModals } from '@/contexts/ModalContext';
import { useTranslations } from 'next-intl';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useCallback, useEffect } from 'react';
import Image from 'next/image';
import { useUpdateGlobalUser } from '@/hooks/useUpdateGlobalUser';

type Props = {
  amount: string;
  onOk?: () => void;
};

export const BonusAppliedModal: React.FC<Props> = ({ amount, onOk }) => {
  const modals = useModals();
  const t = useTranslations('modals');
  const reloadUser = useUpdateGlobalUser();

  useEffect(() => {
    reloadUser();
  }, [reloadUser]);

  const onClose = useCallback(() => {
    onOk?.();
    modals.close('bonus-applied-modal');
  }, [modals, onOk]);

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <div className='flex flex-col items-center text-center gap-[16px]'>
          <Image alt='' src='/assets/images/coins.jpg' width={289} height={289} quality={100} />

          <DialogHeader className='items-center text-center'>
            <DialogTitle>{t('bonusCoins.header', { amount })}</DialogTitle>
            <DialogDescription>{t('bonusCoins.sub_header')}</DialogDescription>
          </DialogHeader>
        </div>

        <div className='flex flex-col gap-[10px] w-full'>
          <Button
            variant='default'
            onClick={onClose}
            className='h-[48px] w-full rounded-[16px] text-bg-day text-[16px]'
          >
            {t('bonusCoins.button')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
